import { useContext, useEffect, useState } from 'react';
import ReactModal from 'react-modal';

import { GroupDetailInterface, UserGroupInterface } from 'types/user';
import { ModalContext } from 'context/ModalContext';
import { useAuth } from 'context/AuthContext';
import { getUserGroup } from 'services/dashboard.service';

import { IoIosClose } from 'react-icons/io';

type Props = {
  group: {
    nome: string | undefined;
    total: number | undefined;
    grupo_definido?: boolean;
  };
};

export function GroupDetailModal({ group }: Props) {
  const { user } = useAuth();
  const { openModal, closeModal } = useContext(ModalContext);

  const modalID = 'group-detail';

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [groupDetail, setGroupDetail] = useState<GroupDetailInterface[]>();

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  function mountGroupDetail(groups: UserGroupInterface[]) {
    const table: any = [];

    if (groups?.length) {
      groups.forEach((group: UserGroupInterface, index) => {
        const prefixoTable = table.find((x: any) => x.prefixo === group.prefixo);

        if (prefixoTable) {
          const ro = prefixoTable.ROs.find((x: any) => x.ro === group.ro);

          if (ro) {
            if (!ro.funcoes.find((x: any) => x.cod_funcao === group.cod_funcao)) {
              ro.funcoes.push({
                funcao: group.funcao,
                cod_funcao: group.cod_funcao,
              });
            }
          } else {
            prefixoTable.ROs.push({
              ro: group.ro,
              funcoes: [
                {
                  funcao: group.funcao,
                  cod_funcao: group.cod_funcao,
                },
              ],
            });
          }
        } else {
          table.push({
            nome_dependencia: group.nome_dependencia,
            prefixo: group.prefixo,
            ROs: [
              {
                ro: group.ro,
                funcoes: [
                  {
                    funcao: group.funcao,
                    cod_funcao: group.cod_funcao,
                  },
                ],
              },
            ],
          });
        }
      });

      setGroupDetail(table);
    }
  }

  useEffect(() => {
    setIsOpen(openModal === modalID);
  }, [openModal]);

  useEffect(() => {
    async function loadUserGroup() {
      if (user?._id) {
        const data: UserGroupInterface[] = await getUserGroup(user._id);
        mountGroupDetail(data);
      }
    }

    if (!user) return;

    loadUserGroup();
  }, [user]);

  if (!groupDetail?.length) return <></>;

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="rb-modal-overlay rb-modal-overlay--top"
        contentElement={() => (
          <div className="rb-modal rb-modal--lg">
            <button className="rb-modal__close" aria-label="Fechar" onClick={() => closeModal()}>
              <IoIosClose size={26} />
            </button>

            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Grupo {group?.nome}</h1>
            </div>

            <div className="overflow-x-auto">
              <table>
                <thead>
                  <tr>
                    <th>Cod. da função</th>
                    <th>Nome da função</th>
                    <th>Nome da organização</th>
                  </tr>
                </thead>
                <tbody>
                  {groupDetail.map(group =>
                    group.ROs.map(ro =>
                      ro.funcoes.map(funcao => (
                        <tr key={`${group.nome_dependencia}-${ro.ro}-${funcao.cod_funcao}`}>
                          <td>{funcao.cod_funcao}</td>
                          <td>{funcao.funcao}</td>
                          <td>{group.nome_dependencia}</td>
                        </tr>
                      )),
                    ),
                  )}
                </tbody>
              </table>
            </div>

            <p className="rb-modal__text">
              Total de colaboradores do grupo: <strong>{group?.total} pessoas.</strong>
            </p>
          </div>
        )}
      />
    </>
  );
}
